import React, { useEffect } from "react";
import "../../pages/css/Academies.css";
// import { useGetAcademyQuery } from "./../../slices/userApiSlice";
import { toast } from "sonner";

const Academies = ({ academies, isLoading, error }) => {
  // const { data: academies, isLoading, error } = useGetAcademyQuery();
  useEffect(() => {
    if (error) {
      toast.error("Failed to Load Academies", {
        description: "Unable to load academies. Please try again later.",
      });
    }
  }, [error]);

  return (
    <div className="bento-container">
      <div className="atitlediv">
        <h1 className="title">Gyalsung Academies</h1>
        <div className="fb-title-accent">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <p className="mr-section-desc">
          Discover our specialized training centers designed to empower and
          shape the future leaders of our nation.
        </p>
      </div>
      <div className="bento-grid">
        {isLoading ? (
          <p>Loading academies...</p>
        ) : error ? (
          <p style={{ color: "red" }}>Error fetching academies</p>
        ) : (
          academies?.map((academy, index) => (
            <div
              key={academy.academyId || academy.id}
              className={`bento-item item-${index % 5}`}
              style={{
                backgroundImage: `url(${academy.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              <div className="aname">
                <h1>{academy.name}</h1>
                <p>{academy.location}</p>
              </div>
              <div className="overlay">
                <p className="adescription">{academy.description}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Academies;
